"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var storage = __importStar(require("../../utils/storage"));
/**
 * States of the Cache key
 */
var EMPTY = 'EMPTY';
var FETCHING = 'FETCHING';
var FETCHED = 'FETCHED';
/**
 * Cache prefix in storage
 */
var prefix = 'cached-';
/**
 * Duration between retrying cache get (if in FETCHING)
 */
var retryDuration = 200;
/**
 * Sleeps specified number of miliseconds using async method.
 * @param {Number} ms
 */
function sleep(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
/**
 * Gets data asynchroniously from cache.
 *
 * Data is returned right ahead if present, asynchroniously
 * if we need to wait for another caller to provide data or prefetch is recorded otherwise.
 *
 * @param {String} key Cache key
 * @param {Boolean} prefetch Determine if prefetch should be marked
 * @param {Number} validDuration Valid duration of the stored data before considered obsolete. In seconds.
 */
exports.getDataFromCache = function (key, prefetch, validDuration) { return __awaiter(_this, void 0, void 0, function () {
    var cacheEntry, data, fetchedTime, fetched, now, validUntil;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(prefetch && getCacheState(key, validDuration) === EMPTY)) return [3 /*break*/, 1];
                putPrefetchToCache(key);
                return [3 /*break*/, 4];
            case 1:
                cacheEntry = loadCachedData(key);
                if (!cacheEntry) return [3 /*break*/, 4];
                data = cacheEntry.data, fetchedTime = cacheEntry.fetchedTime, fetched = cacheEntry.fetched;
                now = Date.now();
                validUntil = fetchedTime + validDuration * 1000;
                if (!(validUntil > now)) return [3 /*break*/, 4];
                if (!fetched) return [3 /*break*/, 2];
                return [2 /*return*/, Promise.resolve(data)];
            case 2: return [4 /*yield*/, sleep(retryDuration)];
            case 3:
                _a.sent();
                return [2 /*return*/, exports.getDataFromCache(key, prefetch, validDuration)];
            case 4: return [2 /*return*/, Promise.resolve(null)];
        }
    });
}); };
/**
 * Puts data to cache. Setting the data as fetched.
 *
 * @param {String} key Cache key
 * @param {Object} data Data to cache
 */
exports.putDataToCache = function (key, data) {
    var now = Date.now();
    var cacheEntry = { data: data, fetchedTime: now, fetched: true };
    var cacheEntryEncoded = JSON.stringify(cacheEntry);
    storage.put(prefix + key, cacheEntryEncoded);
};
/**
 * Loads data from storage and parse stored JSON.
 *
 * If stored value can not be decoded, null is returned
 *
 * @param {String} key Cache key
 */
var loadCachedData = function (key) {
    var cacheEntryEncoded = storage.get(prefix + key);
    if (cacheEntryEncoded !== undefined) {
        try {
            return JSON.parse(cacheEntryEncoded);
        }
        catch (ignored) { }
    }
    return null;
};
/**
 * Gets state of the cache key. Returns EMPTY, FETCHING or FETCHED.
 *
 * @param {String} key Cache key
 */
var getCacheState = function (key, validDuration) {
    var cacheEntry = loadCachedData(key);
    if (cacheEntry) {
        var fetchedTime = cacheEntry.fetchedTime, fetched = cacheEntry.fetched;
        var now = Date.now();
        var validUntil = fetchedTime + validDuration * 1000;
        if (validUntil > now) {
            if (fetched) {
                return FETCHED;
            }
            else {
                return FETCHING;
            }
        }
    }
    return EMPTY;
};
/**
 * Marks cache key as fetching, so another requester will wait for data to fetch only once
 *
 * @param {String} key Cache key
 */
var putPrefetchToCache = function (key) {
    var now = Date.now();
    var cacheEntry = { fetchedTime: now, fetched: false };
    var cacheEntryEncoded = JSON.stringify(cacheEntry);
    storage.put(prefix + key, cacheEntryEncoded);
};
//# sourceMappingURL=cache.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/cache.js
// module id = 2033
// module chunks = 0